import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
  font-size: inherit;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  align-items: center;
  width: ${(props) => (props.width ? props.width : '50%')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
`;

export const Label = styled.div`
  font-size: inherit;
  margin-left: 15px;
`;

export const Image = styled.img`
  vertical-align: middle;
  width: 55px;
  height: auto;
  border-radius: 2px;
  @media (max-width: 1600px) {
    width: 35px;
    height: auto;
  }
`;

export const PlaceholderImage = styled.img`
  vertical-align: middle;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #330033;
  background-color: #d0cd16;
  @media (max-width: 1600px) {
    width: 25px;
    height: 25px;
  }
`;
